import { Grid, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

export const PageTitleWrapper = ({ children }) => {
  const classes = useStyles();
  return (
    <Grid container className={classes.titleWrapper}>
      <Grid item xs={12} className={classes.pageTitleWrapper}>
        {children}
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  pageTitleWrapper: {
    '@media (min-width: 768px)': {
      flex: 1
    }
  },
  titleWrapper: {
    marginBottom: theme.spacing(0.5)
  }
}));
